// مرتب سازی از قیمت کم به زیاد
export function sortVarieties(product) {
    if (product == null) {
        return []
    }
    if (!product.varieties) {
        return []
    }
    return [...product.varieties].sort((item1, item2) => {
        return (item1.final_price.amount) - (item2.final_price.amount)
    })
}

export function getImages(product) {
    let varieties = sortVarieties(product)
    if (product.images != '') {
        return product.images
    } else {
        let images = []
        for (let i = 0; i < varieties.length; i++) {
            if (varieties[i].images != '') {
                images = varieties[i].images
                break;
            }
        }
        return images
    }
}


// فیلتر کردن شیپینگ ها بر اساس آدرس
export function setShipping(address, shippings) {
    let shipping = [];
    shippings.forEach((el) => {
        if (el.provinces != "") {
            if (
                el.cities != "" && el.cities.filter(
                    (city) => city.province_id == address.city.province_id
                ) != ""
            ) {
                if (el.cities.find((p) => p.id == address.city_id)) {
                    shipping.push(el);
                }
            } else if (
                el.provinces.filter(
                    (province) => province.id == address.city.province_id
                ) != ""
            ) {
                shipping.push(el);
            }
        } else {
            shipping.push(el);
        }
    });
    return shipping;
}

export function getShippingPrice(address, shipping, amount) {
    let check = () => {
        if (shipping) {
            if (shipping.provinces != '') {
                let shippingItem = null
                shippingItem = shipping.cities.find((city) => {
                    return city.id == address.city.id;
                });
                if (shippingItem) {
                    return shippingItem.pivot.price;
                }
                shippingItem = shipping.provinces.find((province) => {
                    return province.id == address.city.province_id;
                })
                if (shippingItem) {
                    return shippingItem.pivot.price
                } else {
                    return shipping.default_price;
                }
            } else {
                return shipping.default_price;
            }
        } else {
            return 0
        }
    }

    if (shipping) {
        if (shipping.free_threshold) {
            if (shipping.free_threshold >= amount) {
                return check()
            } else {
                return 0;
            }
        } else {
            return check()
        }
    } else {
        return 0;
    }
}


// پیدا کردن قیمت سفارش در لیست فاکتور ها

export function findPriceOrder(list) {
    let amount = null;
    list.forEach(element => {

        if (element.status.toLowerCase() == "success") {
            amount = element.amount;
            return;
        }

    });
    return amount;
}
// دریافت مجموع قیمت براساس قیمت تخفیف و تعداد
export function getSumPrice(price, discount, count) {
    if (discount == null) {
        discount = 0
    }
    return ((price * count) - (discount * count));
}
// پیدا کردن نحوه پرداخت
export function findPayments(type, paymentObject) {
    if (type == "gateway") {
        let output = "درگاه مجازی" + "/" + paymentObject.gateway_label
        return output
    } else {
        return "کیف پول"
    }
}


// دریافت وضعیت استاتوس هر سفارش
export function getOrderStatus(status) {

    if (status.toUpperCase() == "NEW") {
        return "جدید";
    } else if (status.toUpperCase() == "CANCELED") {
        return "لغو شده";
    } else if (status.toUpperCase() == "IN_POROGRESS") {
        return "در دست اقدام";
    } else if (status.toUpperCase() == "DELIVERED") {
        return "تکمیل شده";
    } else if (status.toUpperCase() == "WAIT_FOR_PAYMENT") {
        return "در انتظار پرداخت";
    }
}

// دریافت وضعیت استاتوس هر فاکتور
export function getInvoicesStatus(status) {

    if (status.toUpperCase() == "SUCCESS") {
        return "پرداخت شده";
    } else if (status.toUpperCase() == "PENDING") {
        return " در انتظار پرداخت";
    } else if (status.toUpperCase() == "FAILED") {
        return " ناموفق";
    }
}
export function cartListsOpen() {

    let cartLists = document.getElementsByClassName("cart-lists")[0];
    const cartListsCloseResp = document.getElementsByClassName(
        "cart-lists-close-resp"
    )[0];
    // let cartFixed=document.getElementsByClassName('cart-fixed')[0];
    // cartFixed.style.left="-150px"
    cartListsCloseResp.style.display = "block";
    cartLists.style.left = "0";
}
export function pay(makeResponse) {
    if (makeResponse.method === 'GET' || makeResponse.method === 'get') {
        window.location.href = makeResponse.url;
    } else {
        let form = document.createElement('form');
        form.method = makeResponse.method;
        form.action = makeResponse.url;
        if (makeResponse.inputs && Object.entries(makeResponse.inputs).length) {
            Object.entries(makeResponse.inputs).forEach((keyVal) => {
                let key = keyVal[0];
                let value = keyVal[1];
                let input = document.createElement('input')
                input.name = key;
                input.type = 'hidden';
                input.value = value;
                form.appendChild(input);
            });
        }
        document.querySelector('body').appendChild(form);
        form.submit()
    }
}